export * from './IconTrash';
